/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const fr_project_document_management_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Application de gestion électronique de documents (GED). Plateforme unifiée avec tableau de bord intelligent et automatisations de tâches d'archivage de documents (notes, courriers, etc).`)
};

const en_project_document_management_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Electronic document management (EDM) application. Unified platform with intelligent dashboard and automated document archiving tasks (notes, letters, etc).`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const project_document_management_description = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.project_document_management_description(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("project_document_management_description", locale)
	if (locale === "fr") return fr_project_document_management_description(inputs)
	return en_project_document_management_description(inputs)
};